import { Form, Button, Modal, Input } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { declineRequest, signRequest } from "../../store/api/axiosApi";
import { signularisApi } from "../../store/api/signularisApi";
import { MAIN_PAGE_ROUTE, META_DOCUMENT_INFO_ROUTE } from "../../routing/consts";
import { documentTemplates } from "../../const";
import { DocTemplateType, Signature } from "../../types/types";
import { RootState } from "../../store/store";
import style from './documentCard.module.scss';
import { ClockCircleOutlined, UserOutlined, FileTextOutlined, LinkOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Item } = Form;

function DocumentCard(prop: {
    reference: string, docType: DocTemplateType, referenceType: string,
    id: string, title: string, brief: string, time: string, owner: string,
    fileId: string, viewButtons: boolean, signatures: Signature[]
}) {
    const [signModalVisible, setSignModalVisible] = useState(false);
    const [declineModalVisible, setDeclineModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState("");
    const [comment, setComment] = useState("");

    const userInfo = useAppSelector((state: RootState) => state.userinfo);
    const dispatch = useAppDispatch();

    const getSigCount = () => prop.signatures.filter(s => s.status === 1 || s.status === 2).length;

    const handleAction = async (type: 'sign' | 'decline') => {
        setLoading(true);
        if (type === 'sign') {
            await signRequest(prop.id, password, prop.fileId, userInfo, getSigCount(), comment);
        } else {
            await declineRequest(prop.id, password, prop.fileId, userInfo, getSigCount(), comment);
        }
        setLoading(false);
        setSignModalVisible(false);
        setDeclineModalVisible(false);
        setPassword("");
        setComment("");
        dispatch(signularisApi.util.invalidateTags(['MetaDocument']));
    };

    return (
        <div className={style.card}>
            <div className={style.header}>
                <h3 className={style.title}>{prop.title}</h3>
                <Link className={style.linkMore} to={`${MAIN_PAGE_ROUTE}/${META_DOCUMENT_INFO_ROUTE}/${prop.id}`}>Подробнее</Link>
            </div>

            <div className={style.info}>
                <div className={style.item}><ClockCircleOutlined className={style.icon} /> {prop.time}</div>
                <div className={style.item}><UserOutlined className={style.icon} /> {prop.owner}</div>
            </div>

            <div className={style.brief}>
                {documentTemplates[prop.docType] ? (
                    <span>{prop.brief} «<strong>{documentTemplates[prop.docType]}</strong>»</span>
                ) : <span>{prop.brief}</span>}
            </div>

            {(+prop.reference || isNaN(+prop.reference)) && (
                <div>
                    <Link className={style.refLink} to={`${MAIN_PAGE_ROUTE}/${META_DOCUMENT_INFO_ROUTE}/${prop.reference}`}>
                        <LinkOutlined /> Ссылка на документ {prop.reference}
                    </Link>
                </div>
            )}

            {prop.viewButtons && (
                <div className={style.footer}>
                    <Button type="primary" onClick={() => setSignModalVisible(true)}>
                        Подписать
                    </Button>
                    <Button type="default" danger onClick={() => setDeclineModalVisible(true)}>
                        Отклонить
                    </Button>
                </div>

            )}

            {/* Модалки оставляем, но можно добавить им className для стилизации */}
            <Modal
                title="Подписание документа"
                visible={signModalVisible}
                onCancel={() => setSignModalVisible(false)}
                onOk={() => handleAction('sign')}
                confirmLoading={loading}
                okText="Подтвердить"
                cancelText="Отмена"
            >
                <TextArea placeholder="Ваш комментарий (необязательно)" rows={3} onChange={e => setComment(e.target.value)} style={{ marginBottom: 16 }} />
                <Input.Password placeholder="Введите пароль" onChange={e => setPassword(e.target.value)} />
            </Modal>

            <Modal
                title="Отклонение документа"
                visible={declineModalVisible}
                onCancel={() => setDeclineModalVisible(false)}
                footer={[
                    <Button key="back" onClick={() => setDeclineModalVisible(false)}>Отмена</Button>,
                    <Button key="submit" type="primary" danger loading={loading} onClick={() => handleAction('decline')}>Отклонить</Button>
                ]}
            >
                <TextArea placeholder="Причина отклонения (обязательно)" rows={4} onChange={e => setComment(e.target.value)} style={{ marginBottom: 16 }} />
                <Input.Password placeholder="Введите пароль" onChange={e => setPassword(e.target.value)} />
            </Modal>
        </div>
    );
}

export default DocumentCard;
